<template>
    <div>

      <div v-if="filter.search && channels.length > 0" class="text-center clear"><a href="#/" @click="clearFilter('search')">Clear search</a></div>

    <div style="padding-top:10px;">
    <div class="card">

          <div class="card-body pb-2">
            
      <div v-if="loading" class="text-center pb-2"><i class="fas fa-spinner fa-spin fa-2x"></i></div>
      <div v-else-if="channels.length == 0" class="text-center pb-3">
        <div>No channels</div>
        <div v-if="filter.search">
        <div class="pt-2 clear"><a v-if="filter.search" href="#/" @click="clearFilter('search')">Clear search</a></div>
        </div>
      </div>

        <span v-else>

        <!-- Desktop -->
        <div class="py-2 sticky-top" style="background-color:white; top:52px; z-index:900">
          <table class="table d-none d-md-table">
              <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3" width="35%">Channel</th>
                  <th class="pl-3" width="15%"><span :class="active_subs">Subscribers</span></th>
                  <th class="pl-3" width="10%"><span :class="active_videos">Videos</span></th>
                  <th class="pl-3" width="10%"><span :class="active_months">Months</span></th>
                  <th class="pl-3" width="15%"><span :class="active_spv">Subs Per Video</span></th>
                  <th class="first-right pl-3" width="20%"><span :class="active_performance">Performance</span></th>
                </tr>
              </thead>
        </table>
        </div>

        <table class="table d-none d-md-table">
              <tbody>
                <tr class="body" v-for="(channel, index) in channels" :key="index" @click="showChannelModal(channel)">
                    <td class="pl-3 font-weight-bold" width="35%">{{ channel.name }}</td>
                    <td class="pl-3" width="15%">{{ formatNumber(channel.subscribers) }}</td>
                    <td class="pl-3" width="10%">{{ formatNumber(channel.videos) }}</td>
                    <td class="pl-3" :title="`Started on ${channel.started}`" width="10%">{{ channel.months }}</td>
                    <td class="pl-3" width="15%">{{ formatNumber(channel.subscriberRate) }}</td>
                    <td class="pl-3" width="20%">{{ channel.rank }}</td>
                </tr>
              </tbody>
            </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">Channels</th>
                </tr>
              </thead>
          <tbody>

            <tr class="body" v-for="(channel, index) in channels" :key="index" @click="showChannelModal(channel)">
  
        <td class="pl-2 text-center">
            <div class="font-weight-bold">{{ channel.name }}</div>
            <div><i class="fas fa-user-friends"></i> {{ formatNumber(channel.subscribers) }} subscribers</div>
            <div><i class="fab fa-youtube"></i> {{ formatNumber(channel.videos) }} videos</div>
            <div><i class="far fa-clock"></i> {{ channel.months }} months</div>
            <div><i class="fas fa-mouse-pointer"></i> {{ formatNumber(channel.subscriberRate) }} subs per video</div>
            <div><i class="fas fa-star"></i> {{ channel.rank }}</div>
        </td>

            </tr>
          </tbody>
        </table>

        </span>

          </div>
</div>
</div>
<channel-modal v-if="channelInfo" :channel="channelInfo" ref="ChannelModal"></channel-modal>
</div>
</template>

<script>
export default {
props: ['filter'],

  data() {
    return {
      channels: [],
      channelInfo: {},
      loading: false,
      active_subs: null,
      active_videos: null,
      active_months: null,
      active_spv: null,
      active_performance: null,
    };
  },

  // mounted() {

  //   if(localStorage.getItem('propper_filter')) {

  //   } else {
  //     this.getChannels();
  //   }

  // },

  watch: {
  filter() {
    this.getChannels();
    }
  },

  methods: {

    clearFilter(type) {

      switch(type) {
        case 'search': this.search = null; this.filter.search = null; break;
      }

      this.getChannels();
      this.$emit('myClearFilter', type);

    },

    showChannelModal(channel) {
      let handle = channel.handle;
      this.channelInfo = channel;
      this.$refs.ChannelModal.getVideos(handle);
      this.$bvModal.show('bv-channel-modal');
    },

    updateFilter(val) {
        this.filter = val;
     },

    getChannels() {

      this.loading = true;

      axios
        .post('/channel/list', {filter: this.filter})
        .then((response) => {

          // update channels
          this.channels = response.data;
          this.loading = false;

          // update sort label
          this.active_subs = this.filter.sortBy.id == 2 ? 'active_subs' : null;
          this.active_videos = this.filter.sortBy.id == 3 ? 'active_videos' : null;
          this.active_months = this.filter.sortBy.id == 4 ? 'active_months' : null;
          this.active_spv = this.filter.sortBy.id == 5 ? 'active_spv' : null;
          this.active_performance = this.filter.sortBy.id == 1 ? 'active_performance' : null;

          // store filter
          localStorage.setItem('propper_filter', JSON.stringify(this.filter));

        });
    },

  },
};
</script>

<style scoped>
.prop-input {width:100%;background-color: #fff; color: #000; border: none;border-radius:0.25rem;padding: 0.48rem 0.4rem;}
.prop-input:hover {cursor: pointer;}
.active_performance, 
.active_videos,
.active_subs, 
.active_months, 
.active_spv {color: #ffff80; }
.clear {font-size:0.9rem;}
label.top {
  color: #fff;
  font-size: 0.9rem;
}
div.v-select {
  background: #fff;
  border-radius: 0.25rem;
}
.form-control {
  font-size: 1.5rem;
  font-weight: bold;
}
</style>
